import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'normalize.css'
import '@carto/airship-style/dist/airship.css'
import { defineCustomElements } from '@carto/airship-components/dist/loader'
import messages from './locales/messages'
import VueI18n from 'vue-i18n'
import VueAnalytics from 'vue-analytics'

Vue.use(VueI18n)
Vue.config.productionTip = false
Vue.config.ignoredElements = [/as-\w+/]
defineCustomElements(window)
const i18n = new VueI18n({
  locale: 'en', // set locale, beware of the locale numerical separator ;-)
  fallbackLocale: 'en',
  messages // set locale messages
})

Vue.use(VueAnalytics, {
  id: 'UA-63170826-1',
  router,
  debug: {
    enabled: false,
    sendHitTask: true
  }
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
